import React from "react";

const Numbers_and_Strings = () => {
  return (
    <div>
      <h1>Numbers_and_Strings Component</h1>
      <p>Content for Numbers_and_Strings goes here...</p>
    </div>
  );
};

export default Numbers_and_Strings;
